import { type Genre } from '@tmdb-graphql-api/schema/types';

export const formatGenres = (genres: Genre[] = []) => genres.map(({ id, name }) => ({ id, name }));
